var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../box/Box";
import Grid from "./grid/12/Grid";
export default (function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(Grid, __assign({ p: 2, gridTemplateColumns: "repeat(12, 1fr)" }, rest),
        React.createElement(Box, { p: 2, gridColumn: ["5 / -1", "3 / 7"], gridRow: ["3 / span 2", "1"], zIndex: 2 }, children[0]),
        React.createElement(Box, { p: 2, gridColumn: ["1 / 10", "8 / 12"], gridRow: ["1 / 4", "1"], zIndex: 1 }, children[1])));
});
//# sourceMappingURL=ImgDualPortrait.js.map